<template>
  <footer class="site2026-footer">
    <div class="container">
      <div class="site2026-footer-grid">
        <div>
          <a href="/" class="site2026-logo" style="font-size:24px">
            <span class="site2026-logo-mark" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 19H9a7 7 0 1 1 1.3-13.9A6 6 0 1 1 17.5 19Z" /></svg>
            </span>
            <span>Bmob</span>
          </a>
          <p style="margin-top:10px; font-size:15px; line-height:1.7;">专注于为开发者提供最简单、最快捷的后端云服务解决方案。</p>
          <div class="site2026-footer-qr">
            <img src="@/assets/images/footer-QR.png" alt="关注 Bmob 微信">
            <p>关注 Bmob 微信</p>
          </div>
        </div>
        <div>
          <h5>产品</h5>
          <ul>
            <li><a href="/cloud" class="site2026-footer-link">云数据库</a></li>
            <li><a href="/realtime" class="site2026-footer-link">实时监听</a></li>
            <li><a href="/mcp" class="site2026-footer-link">MCP 服务</a></li>
            <li><a href="/skills" class="site2026-footer-link">Agent Skills</a></li>
            <li><a href="/iot" class="site2026-footer-link">物联网 IoT</a></li>
            <li><a href="/repository/index" class="site2026-footer-link">知识库</a></li>
          </ul>
        </div>
        <div>
          <h5>资源</h5>
          <ul>
            <li><a :href="docUrl" target="_blank" class="site2026-footer-link">开发文档</a></li>
            <li><a :href="docUrl + '/data/restful/develop_doc/'" target="_blank" class="site2026-footer-link">API 参考</a></li>
            <li><a href="/downloads" class="site2026-footer-link">SDK 下载</a></li>
            <li><a href="/prompt" class="site2026-footer-link">提示词广场</a></li>
          </ul>
        </div>
        <div>
          <h5>公司</h5>
          <ul>
            <li><a href="/about" class="site2026-footer-link">公司简介</a></li>
            <li><a href="/site/news" class="site2026-footer-link">新闻动态</a></li>
            <li><a href="/service" class="site2026-footer-link">服务条款</a></li>
            <li><a href="/privacy" class="site2026-footer-link">隐私政策</a></li>
          </ul>
        </div>
      </div>
      <div class="site2026-footer-bottom">
        © 2012-{{ currentYear }} 元素（深圳）软件有限公司
        <span style="opacity:0.7; padding: 0 10px;">|</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" class="site2026-footer-link">粤ICP备2024251222号</a>
        <span style="opacity:0.7; padding: 0 10px;">|</span>
        <a href="javascript:;" class="site2026-footer-link">增值电信业务经营许可证：粤B2-20250911</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Site2026Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    docUrl() {
      return this.$store.getters.docUrl || 'https://doc.bmob.cn/'
    }
  }
}
</script>

<style scoped>
/* 样式统一在 layout/site2026.vue 中 */
</style>
